import Helpers from './Helpers'

const VALUE_INCREMENT = 1
const VALUE_DECREMENT = -1

class ButtonCounter {
    constructor(control) {
        this.control = control

        this.name = control.getAttribute("data-name")
        this.code = control.getAttribute("data-qs-code")
        this.buttons = control.getElementsByTagName('button')
        this.input = control.getElementsByTagName('input')[0]
        this.text = control.getElementsByTagName('p')[0]
        this.max = parseInt(control.getAttribute('data-max')) || 10
        this.min = parseInt(control.getAttribute('data-min')) || 0
        this.defaultValue = control.getAttribute('data-default-value') || '0'
        this.mousedownEvent = -1
        this.mousedownInterval = 200
        this.mousedownInitialInterval = 600

        this.buttonClickEvent()
    }

    getValue() {
        return this.input.value
    }

    buttonClickEvent() {
        const self = this
        new Helpers(this.buttons).eventListener((e) => {
            const button = e.target
            
            if (button.getAttribute('aria-label') == 'Plus') {
                self.mouseDown(VALUE_INCREMENT)
            } else if (button.getAttribute('aria-label') == 'Minus') {
                self.mouseDown(VALUE_DECREMENT)
            }

        }, 'mousedown')

        new Helpers(this.buttons).eventListener((e) => {
            self.mouseUp()
        }, 'mouseup')

        new Helpers(this.buttons).eventListener((e) => {
            self.mouseUp()
        }, 'mouseout')

    }

    updateDisplay() {
        let text = parseInt(this.input.value) != 1 ? this.text.getAttribute("data-plural") : this.text.getAttribute("data-singular")

        this.text.innerText = text.replace("{0}", this.input.value)
    }

    mouseDown(direction) {
        const self = this
        if (this.mousedownEvent == -1) {

            if (direction == VALUE_INCREMENT) {
                this.increment()
                this.mousedownEvent = setTimeout(() => {
                    self.incrementTimeout()
                }, this.mousedownInitialInterval)
            }

            if (direction == VALUE_DECREMENT) {
                this.decrement()
                this.mousedownEvent = setTimeout(() => {
                    self.decrementTimeout()
                }, this.mousedownInitialInterval)
            }
        }
    }

    mouseUp() {
        if (this.mousedownEvent != -1) {
            clearTimeout(this.mousedownEvent)
            this.mousedownEvent = -1
        }
    }

    increment() {
        if (this.input.value < this.max) {
            this.input.value = parseInt(this.input.value) + 1
            this.updateDisplay()
            this.raiseEvent()
        }
    }

    incrementTimeout() {
        this.increment()
        this.mousedownEvent = setTimeout(() => {
            this.incrementTimeout()
        }, this.mousedownInterval)
    }

    decrement() {
        if (this.input.value > this.min) {
            this.input.value = parseInt(this.input.value) - 1
            this.updateDisplay()
            this.raiseEvent()
        }
    }

    decrementTimeout() {
        this.decrement()
        this.mousedownEvent = setTimeout(() => {
            this.decrementTimeout()
        }, this.mousedownInterval)
    }

    raiseEvent() {
        this.control.dispatchEvent(new CustomEvent('change'))
    }

    setValue(value) {
        this.input.value = value
        this.updateDisplay()
    }

    reset() {
        this.setValue(this.defaultValue)
    }
}

export default ButtonCounter